import type { FaireProductEntity } from "../../entity_types/product";

export const p_dee9xrvvmn: FaireProductEntity = {
  token: "p_dee9xrvvmn",
  type: "product",
  name: "Sex Serum (Travel)",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/f740da52b078a536fa4cb79a50c5d7606bb45bb337b8aaee26a9d9787fa887bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/893490bd19bdf6661294f759fd0df8f96ac417c365823d00837e2ed3d6ef0f1a.jpeg",
    "https://cdn.faire.com/fastly/eb263e1e2f2e7db1d28c37a67f886b844f40e37a79bf6a51ea39b23ee54a52b9.jpeg",
    "https://cdn.faire.com/fastly/b6f56ce64a3c68bb2f3ead95dbc0bce77e92d4909611208ba8e2f07c4baa4fd6.jpeg",
    "https://cdn.faire.com/fastly/262b60c9b4d48c5285f21b42731d8d651995595ed2928372db50baf9e99e7a66.jpeg",
    "https://cdn.faire.com/fastly/0d8582b8bdf6dc617b9d8a03738ebabe16bbf35742ef4961091874ec404df491.jpeg",
  ],
  priceDollars: 15.75,
  description:
    "A travel-size, water-based, silicone-free serum delivering lasting comfort and deep hydration without stickiness or residue. Infused with Hyaluronic Acid to draw in moisture, calming Aloe to soothe, and mood-shifting Adaptogens to heighten connection through the senses, it moves effortlessly with the body to enhance pleasure and intimacy. pH-balanced, fragrance-free, and gynecologist and dermatologist tested.\n",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:37.442Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
